import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { SnActionConfig } from '@lib/ui/actions';

import { CdkDrag } from '@angular/cdk/drag-drop';

@Component({
  selector: 'fs-drag-bar',
  templateUrl: './drag-bar.component.html',
  styleUrls: ['./drag-bar.component.scss'],
})
export class DragBarComponent {
  @ViewChild(CdkDrag)
  public readonly drag: CdkDrag;

  @Output()
  public readonly closeDialog = new EventEmitter<boolean>();

  @Output()
  public readonly channel = new EventEmitter<boolean>();

  @Input()
  public actions: SnActionConfig[];

  @Input()
  public secondaryActions: SnActionConfig[];

  @Input()
  public tertiaryActions: SnActionConfig[];

  @Input()
  public header: string;

  public disableTertiaryActions: boolean = false;

  constructor(private readonly _cd: ChangeDetectorRef) {}

  public close(): void {
    this.closeDialog.emit(true);
  }

  public updateDisabledBtns(value: boolean): void {
    this.disableTertiaryActions = value;
    this._cd.detectChanges();
  }
}
